import { Appl } from "../../../core/Appl";
import { LovService } from "./LovService";

export default class LovModule {
    public static init(): void {
        Appl.Services.add('ILovService', LovService);
    }
}